import { useMutation } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";
import toast from "react-hot-toast";

export const useUpdateUser = () => {
  return useMutation({
    mutationFn: async (userData) => {
      const endpoint = `${WiMuleSQL}/api/Auth/UpdateUserData`; // Update endpoint only

      try {
        const response = await fetch(endpoint, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userData),
        });
        console.log("request to add update user with data", userData);
        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }

        return await response.json();
      } catch (error) {
        throw new Error(error.message);
      }
    },
    onSuccess: (data) => {
      // Handle success
      toast.success(data.message || "User updated successfully");
    },
    onError: (error) => {
      // Handle error
      toast.error(error.message || "Failed to update user");
    },
  });
};
